import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { adminApi } from '../lib/api';
import { PageHeader, Loading, ErrorBox, Badge } from '../components/ui';

export function StoresPage() {
  const qc = useQueryClient();
  const stores = useQuery({ queryKey: ['admin-stores'], queryFn: () => adminApi.stores() });
  const invalidate = () => qc.invalidateQueries({ queryKey: ['admin-stores'] });
  const pause = useMutation({ mutationFn: (id: string) => adminApi.storePause(id), onSuccess: invalidate });
  const resume = useMutation({ mutationFn: (id: string) => adminApi.storeResume(id), onSuccess: invalidate });

  if (stores.isLoading) return <Loading />;
  if (stores.error) return <ErrorBox error={stores.error} />;
  const rows = (stores.data as any)?.items ?? [];

  return (
    <div>
      <PageHeader title="Stores" subtitle="Acceptance, response time and channel health per store" />
      <div className="card">
        <table>
          <thead><tr><th>Store</th><th>Category</th><th>Area</th><th>Orders (7d)</th><th>Acceptance</th><th>Avg accept</th><th>Status</th><th /></tr></thead>
          <tbody>
            {rows.map((s: any) => (
              <tr key={s.id}>
                <td className="font-semibold">{s.name}</td>
                <td>{s.category}</td>
                <td>{s.area}</td>
                <td>{s.orders7d}</td>
                <td>{s.acceptancePct}%</td>
                <td>{s.avgAcceptMin}m</td>
                <td><Badge tone={s.status === 'active' ? 'success' : 'warn'}>{s.status}</Badge></td>
                <td>
                  {s.status === 'active' ? (
                    <button className="btn-outline" onClick={() => pause.mutate(s.id)}>Pause</button>
                  ) : (
                    <button className="btn-outline" onClick={() => resume.mutate(s.id)}>Resume</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!rows.length && <div className="text-sm py-10 text-center" style={{ color: 'var(--text-faint)' }}>No stores yet</div>}
      </div>
    </div>
  );
}
